const ExpandVertical = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 19.24L7.04989 14.29L5.63989 15.71L11.9999 22.07L18.3599 15.71L16.9499 14.29L11.9999 19.24ZM5.63989 8.29L7.04989 9.71L11.9999 4.76L16.9499 9.71L18.3599 8.29L11.9999 1.93L5.63989 8.29Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default ExpandVertical;
